import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const DepartmentSearch = ({ departments, onFilteredResults, onClearSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchType, setSearchType] = useState('all'); // 'all', 'name', 'service'

  useEffect(() => {
    if (!searchTerm?.trim()) {
      onFilteredResults(departments);
      return;
    }

    const filtered = departments?.filter(dept => {
      const term = searchTerm?.toLowerCase()?.trim();
      
      switch (searchType) {
        case 'name':
          return dept?.name?.toLowerCase()?.includes(term) || 
                 dept?.fullName?.toLowerCase()?.includes(term) ||
                 dept?.head?.toLowerCase()?.includes(term);
        
        case 'service':
          return dept?.services?.some(service => 
            service?.toLowerCase()?.includes(term)
          ) || dept?.responsibilities?.some(resp => 
            resp?.toLowerCase()?.includes(term)
          );
        
        default: // 'all'
          return dept?.name?.toLowerCase()?.includes(term) || 
                 dept?.fullName?.toLowerCase()?.includes(term) ||
                 dept?.head?.toLowerCase()?.includes(term) ||
                 dept?.services?.some(service => 
                   service?.toLowerCase()?.includes(term)
                 ) ||
                 dept?.responsibilities?.some(resp => 
                   resp?.toLowerCase()?.includes(term)
                 );
      }
    });

    onFilteredResults(filtered);
  }, [searchTerm, searchType, departments, onFilteredResults]);

  const handleClear = () => {
    setSearchTerm('');
    setSearchType('all');
    onClearSearch();
  };

  const searchTypeOptions = [
    { value: 'all', label: 'ทั้งหมด', icon: 'Search' },
    { value: 'name', label: 'ชื่อหน่วยงาน', icon: 'Building2' },
    { value: 'service', label: 'บริการ', icon: 'FileText' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Search" size={20} className="text-primary" />
        <h3 className="text-lg font-medium text-foreground">
          ค้นหาหน่วยงาน
        </h3>
      </div>
      <div className="space-y-4">
        {/* Search Input */}
        <div className="relative">
          <Input
            type="text"
            placeholder="ค้นหาชื่อหน่วยงาน บุคลากร หรือบริการ..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            className="pr-10"
          />
          {searchTerm && (
            <button
              onClick={handleClear}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground transition-government"
            >
              <Icon name="X" size={16} />
            </button>
          )}
        </div>

        {/* Search Type Filter */}
        <div className="flex flex-wrap gap-2">
          <span className="text-sm text-muted-foreground self-center mr-2">
            ค้นหาใน:
          </span>
          {searchTypeOptions?.map((option) => (
            <button
              key={option?.value}
              onClick={() => setSearchType(option?.value)}
              className={`
                flex items-center space-x-2 px-3 py-1.5 rounded-md text-sm
                transition-government border
                ${searchType === option?.value
                  ? 'bg-primary text-primary-foreground border-primary'
                  : 'bg-background text-foreground border-border hover:bg-muted'
                }
              `}
            >
              <Icon name={option?.icon} size={14} />
              <span>{option?.label}</span>
            </button>
          ))}
        </div>

        {/* Search Results Summary */}
        {searchTerm && (
          <div className="flex items-center justify-between text-sm text-muted-foreground pt-2 border-t border-border">
            <span>
              ผลการค้นหาสำหรับ "{searchTerm}"
            </span>
            <button
              onClick={handleClear}
              className="text-primary hover:text-primary/80 transition-government"
            >
              ล้างการค้นหา
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DepartmentSearch;